import { Box } from '@components/Box';
import { variant } from 'styled-system';
import { styled } from '@styledComponents';
import { JoykitIcon } from '@components/JoykitIcon';
import { themeSpace } from '@utils/styledTheme.util';
import { TypographyVariant } from '@components/themes';
import { Hed4 } from '@components/typography/interVariants';

export const SelectWrapper = styled(Box)`
  width: 100%;
  z-index: 0;
  display: flex;
  align-items: center;
  position: relative;
`;

export interface SelectTypographyProps {
  typography?: TypographyVariant | TypographyVariant[];
}

export const StyledSelect = styled.select<SelectTypographyProps>`
  ${({ typography }) => (typography ? variant({ prop: 'typography', scale: 'typography' }) : Hed4)};
  display: block;
  text-align: right;
  direction: rtl;
  width: 100%;
  margin: 0;
  padding: 0 ${themeSpace(6)} 0 0;
  color: #595959;
  border: none;
  background: transparent;

  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;

  &:focus {
    outline: none;
  }
`;

export const StyledSelectOption = styled.option<SelectTypographyProps>`
  ${({ typography }) => (typography ? variant({ prop: 'typography', scale: 'typography' }) : Hed4)};
  color: #595959;
`;

export const StyledJoykitIcon = styled(JoykitIcon)`
  position: absolute;
  top: 50%;
  right: 0;
  z-index: -1;
  transform: translate(0, -50%);
`;
